import { FC, Fragment, useContext } from "react";
import { UserProgramContext } from "../../context/user-program/user-program";
import { Navigate } from "react-router-dom";
import { ROUTE_HOME } from "../../constants";

type Props = {
  children: React.ReactNode;
};

export const SignInHomeRedirect: FC<Props> = ({ children }) => {
  const { unauthorized } = useContext(UserProgramContext);

  return unauthorized ? (
    <Fragment>{children}</Fragment>
  ) : (
    <Navigate to={ROUTE_HOME} replace={true} />
  );
};
